// extracted by mini-css-extract-plugin
export default {"block":"Block_block__U3GqW","block_blur":"Block_block_blur__KSavu"};